// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gJqa","col":"styles_col__1Raog"};